
export default function useBuildingNo(street: string) {
  let data = street.split(" ");

  if (data && data.length > 0) {
    let houseNumber = data[0];

    if (!isNaN(Number(houseNumber))) return houseNumber

    let rangeHouseNumber = data[0].split("-");

    if (rangeHouseNumber && rangeHouseNumber.length > 1) {
      return rangeHouseNumber.join('-');
    } else {
      let matches = houseNumber.match(/\d+/g)
      if (matches != null) {
        let houseNumberData = houseNumber.split('/');

        if (houseNumberData && houseNumberData.length > 1) {
          return houseNumberData[0];
        }

        return houseNumber
      }

      return ''
    }
  } else {
    return '';
  }
}
